import React from 'react';

import { ErrorMessage, Field } from '@atlaskit/form';

import { AddTestCaseDropdown } from '@qality/common-components/src/organisms/AddTestCaseDropdown';
import { FEATURE_FLAG } from '@qality/common-config';
import { messages } from '@qality/common-messages';
import { TestCycleProject } from '@qality/common-model';

type Props = {
  selectedIssueChanged: (value: Array<string>) => void;
  project: TestCycleProject;
};

type State = {
  hasRequiredError: boolean;
};

export default class AddTestCaseToCycleForm extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasRequiredError: false,
    };
  }

  handleSelectChange = async (selectedIssues: string[]): Promise<void> => {
    this.props.selectedIssueChanged(selectedIssues);
    this.setState({
      hasRequiredError: false,
    });
  };

  showIsRequiredError = (): void => {
    this.setState({
      hasRequiredError: true,
    });
  };

  render(): React.ReactNode {
    const { project } = this.props;
    const { hasRequiredError } = this.state;
    return (
      <Field label='Select Test Case' isRequired name='test-case'>
        {() => (
          <>
            <AddTestCaseDropdown
              projectKey={FEATURE_FLAG.isPremium ? null : project?.key}
              handleSelectChange={this.handleSelectChange}
            />
            {hasRequiredError && (
              <ErrorMessage>
                {messages['error.select.testCase.issue.not.selected']}
              </ErrorMessage>
            )}
          </>
        )}
      </Field>
    );
  }
}
